export const translations = {
  es: {
    header: {
      services: 'Servicios',
      about: 'Lorena',
      testimonials: 'Testimonios',
      products: 'Lorena Beauty Skin Care - Productos',
      space: 'Instalaciones',
      training: 'Formación - Master Class',
      contact: 'Contacto',
      book: 'Agenda Tu Cita',
      bookMobile: 'Agendar',
    },
    hero: {
      title1: '¿Cansada de Gastar Dinero en Tratamientos que ',
      titleHighlight: 'No Funcionan?',
      subtitle:
        'Esto es diferente. Y las más de 50 clientas que llenan Google de 5 estrellas pueden confirmarlo.',
      cta: 'Agenda Tu Consulta Gratis',
    },
    problem: {
      title: 'El Problema',
      titleHighlight: '(Y Por Qué No Es Tu Culpa)',
      guess: 'Déjame adivinar.',
      tried:
        'Has probado cremas. Has ido a realizarte limpiezas faciales. Tal vez hasta compraste esos kits que venden en Instagram con antes y después que parecen milagros.',
      stillHere: 'Y todavía estás aquí.',
      acne: 'Con el acné que no desaparece.',
      spots: 'Con las manchas que vuelven cada verano.',
      cellulite: 'Con esa celulitis que te hace evitar la playa.',
      hair: 'Con ese vello que nunca termina de irse.',
      notDifficult:
        'No es que seas difícil. No es que tu piel sea "un caso perdido."',
      wrongTreatment:
        'Es que nadie te ha dado el tratamiento correcto, diseñado específicamente para TI.',
      generic:
        'Los spas genéricos tienen protocolos genéricos. Te dan lo mismo que le dan a la persona antes y después de ti. Sin importar tu tono de piel, tu historia, tu tipo de manchas, tu nivel hormonal, tu rutina de vida.',
      doesntWork: 'Y eso, en el mundo de la estética real, no funciona.',
    },
    truth: {
      title: 'La Verdad Que Nadie Te Quiere Decir',
      loseMoney:
        'Cada vez que sales de un facial sin resultados, no solo pierdes dinero.',
      loseConfidence: 'Pierdes confianza.',
      believe:
        'Confianza en los tratamientos. Confianza en tu propia piel. Y poco a poco, empiezas a creer que simplemente "así eres tú."',
      accept:
        'Que el acné es parte de tu vida. Que las manchas del embarazo llegaron para quedarse. Que la grasa acumulada no tiene solución sin cirugía.',
      lie: 'Eso es una mentira.',
      soldLie:
        'Una mentira que te han vendido, tratamiento tras tratamiento, porque nadie tomó el tiempo de realmente estudiar tu piel.',
    },
    transformation: {
      title: 'El Momento Que Lo Cambia Todo',
      imagine:
        'Imagínate entrar a un espacio donde, desde el primer segundo, alguien te mira — no tu billetera, no el reloj — sino a ti.',
      listen:
        'Te escucha. Te examina. Te explica qué tiene tu piel, por qué lo tiene, y exactamente qué se va a hacer al respecto.',
      noGuesses:
        'No hay suposiciones. No hay productos al azar. No hay promesas vacías.',
      plan: 'Solo un plan personalizado, ejecutado con 19 años de experiencia clínica, tecnología láser de última generación, y el calor genuino de alguien que ama su trabajo con toda el alma.',
      reality:
        'Eso es lo que viven las clientas de Lorena Beauty House cada vez que cruzan esa puerta.',
    },
    about: {
      title: 'Conoce a Lorena Hernández',
      role: 'Fundadora & Esteticista',
      p1: 'Lorena no llegó a Nueva York con todo resuelto.',
      p2: 'Llegó en 2017, dejando atrás 15 años de carrera construida en la República Dominicana, dispuesta a comenzar desde cero en una ciudad que no regala nada.',
      p3: 'Estudió en Christine Valmy, una de las escuelas de estética y maquillaje más prestigiosas de Nueva York.',
      p4: 'Se graduó. Se certificó. Obtuvo su licencia. Y después de todo eso, la misma escuela donde fue alumna la invitó a ser instructora.',
      p5: '19 años de experiencia. Dos países. Una pasión: tu piel.',
      cred1Title: 'Esteticista Certificada',
      cred1Desc: 'Licenciada en el Estado de Nueva York',
      cred2Title: 'Técnica de Láser',
      cred2Desc: 'Entrenada y certificada',
      cred3Title: 'Asistente Médico & Flebotomista',
      cred3Desc: 'Técnica electrocardiograma',
      cred4Title: 'Maestra Certificada',
      cred4Desc: 'Licencia de maestra del Estado de New York',
      cred5Title: 'Speaker Internacional',
      cred5Desc: 'Talleres en EE.UU. y también internacionales',
      cred6Title: 'Fundadora de Lorena Beauty',
      cred6Desc: 'Fundadora de LORENA BEAUTY SKIN CARE',
      cred7Title: 'EKG Technician',
      cred7Desc: 'Técnica certificada en Electrocardiograma',
    },
    method: {
      title:
        'El Mecanismo: Por Qué Lorena Beauty House Funciona Donde Otros Fallan',
      subtitle1: 'La mayoría de los spas te venden un servicio.',
      subtitle2: 'Lorena te ofrece un protocolo.',
      step1Title: 'DIAGNÓSTICO REAL',
      step1Desc:
        'Antes de tocarte la piel, Lorena la estudia. Tipo de piel, afecciones, historial, estilo de vida. Tu tratamiento se diseña desde cero, solo para ti.',
      step2Title: 'TRATAMIENTO DE PRECISIÓN',
      step2Desc:
        'Tecnología láser certificada + productos de la línea profesional Lorena Beauty + técnicas corporales avanzadas (incluyendo maderoterapia y body sculpting). No hay un solo tratamiento estándar. Cada sesión responde a cómo reaccionó tu piel la vez anterior.',
      step3Title: 'MANTENIMIENTO Y EDUCACIÓN',
      step3Desc:
        'Lorena te enseña. Te explica tu piel. Te da las herramientas para mantener los resultados en casa. Porque una clienta informada es una clienta con resultados permanentes.',
    },
    services: {
      title: 'Nuestros Servicios',
      s1Title: 'Skin Care Facial',
      s1Desc:
        'Limpiezas profundas, hidratación, tratamiento anti-acné, anti-manchas',
      s2Title: 'Body Sculpting',
      s2Desc: 'Reducción de medidas, tonificación, modelado corporal',
      s3Title: 'Venus Legacy',
      s3Desc:
        'Tecnología avanzada de radiofrecuencia y campos magnéticos pulsados para reducción de celulitis, reafirmación de piel, contorno corporal y rejuvenecimiento facial. Resultados visibles desde la primera sesión.',
      s4Title: 'Acné & Manchas',
      s4Desc:
        'Protocolos especializados para melasma, hiperpigmentación, cicatrices',
      s5Title: 'Maquillaje Profesional',
      s5Desc: 'Técnicas profesionales, clases personalizadas',
      s6Title: 'SPA Completo',
      s6Desc: 'Experiencia de bienestar total, cara y cuerpo',
      priceTitle: 'Lista de Precios y Tratamientos',
      priceAlt: 'Lista de precios - Lorena Beauty House',
    },
    testimonials: {
      title: 'Lo Que Dicen Las Que Ya Lo Vivieron',
      google: '5.0 en Google',
      verified: '+53 Reseñas Verificadas',
      t1: 'Sufro de melasma y Lorena me ha ayudado mucho. Desde que empecé con ella mi cara ahora luce tan bonita como si no tuviera melasma.',
      t2: 'Su propietaria Lorena es una maravillosa anfitriona, te recibe con una sonrisa y café en mano. Los productos son personalizados de acuerdo a tu tipo de piel.',
      t3: 'Desde que empecé a hacerle spa, mi cara tiene su brillo y brillo. Este spa realmente atiende a sus clientes con dedicación, calidez y amor.',
      t4: 'Obteniendo muy buenos resultados rápidamente. Súper recomendado para casos de acné.',
      t5: 'Los resultados de mi láser han sido muy buenos. Recomiendo el lugar 100%.',
    },
    cta: {
      riskTitle: 'Riesgo Cero: Tu Primera Consulta Es Gratis',
      riskP1: 'Sabemos que la confianza se gana, no se pide.',
      riskP2: 'Sin presión. Sin compromiso. Sin ventas agresivas.',
      riskP3:
        'Solo una conversación real con Lorena, donde evaluamos tu piel y te decimos exactamente qué necesitas — y qué no.',
      riskP4:
        'Si no sientes que es el lugar correcto para ti, te vas sin gastar un centavo. Pero si sientes lo que sienten todas las que han pasado por esa puerta... bienvenida a tu nueva rutina de belleza.',
      urgencyTitle: 'Urgencia Real',
      urgencyDesc1:
        'Lorena y su equipo de esteticistas trabajan exclusivamente por medio de citas, porque cada clienta recibe atención completamente personalizada. No somos una fábrica de tratamientos. Somos un espacio de transformación.',
      urgencyDesc2: 'Los cupos para nuevas clientas son limitados cada semana.',
      nextStep: 'El Próximo Paso Es Simple',
      bookBtn: 'Agenda Tu Consulta Gratuita Hoy',
      memory:
        'Tu piel tiene memoria. Y el mejor momento para empezar a darle lo que merece... es hoy.',
      faqTitle: 'Preguntas Frecuentes',
      q1: '¿Es muy caro?',
      a1: 'Tu primera consulta es gratis. Los tratamientos se adaptan a tu necesidad y presupuesto. Una piel tratada correctamente desde el inicio te ahorra dinero en productos que no funcionan.',
      q2: '¿Realmente funciona el láser para mi tipo de piel?',
      a2: 'Lorena es Técnica de Láser certificada con experiencia en todo tipo de pieles, incluyendo pieles latinas con pigmentación. Tu evaluación es personalizada.',
      q3: '¿Y si no veo resultados?',
      a3: 'Los resultados están documentados en más de 53 reseñas reales de Google. Y tu primera consulta te permitirá ver si el tratamiento es el correcto antes de comprometerte.',
      q4: 'No tengo tiempo',
      a4: 'Lorena atiende con cita previa, lo que elimina esperas. Los tratamientos se diseñan eficientemente para adaptarse a tu horario.',
      q5: 'He probado de todo y nada funciona',
      a5: 'Exactamente por eso Lorena primero diagnostica. Lo que no ha funcionado es porque no estaba diseñado para tu piel específica.',
    },
    products: {
      badge: 'Distribución Exclusiva',
      title: 'Productos Lorena Beauty',
      desc: 'Línea profesional de skincare desarrollada por Lorena — formulada con ingredientes de alta calidad para resultados reales en tu piel.',
      howToLabel: 'Cómo Utilizar',
      includesLabel: 'Incluye',
      ingredientsLabel: 'Ingredientes',
      p1Name: 'Serum de Semillas de Uva',
      p1Tagline: 'Grapeseed Oil Blend — Humectante antioxidante de uso diario',
      p1Desc:
        'Este poderoso humectante se absorbe fácilmente en la piel previniendo arrugas, estrías, celulitis, manchas, cicatrices, acné y puntos negros. Proporciona protección antioxidante contra los dañinos rayos solares y la contaminación. Apto para todo tipo de pieles.',
      p1HowTo:
        'Masajear suavemente 3 gotas, tanto por la mañana como por la noche.',
      p1Ingredients:
        'Aceite de Semilla de Vitis Vinifera (uva), Proteína Vegetal Hidrolizada, Palmitato de Retinilo (vitamina A), Ácido L-Ascórbico (Vitamina C), Colágeno Hidrolizado.',
      p2Name: 'Radiance — Pieles Pigmentadas',
      p2Tagline: 'Línea intensiva para manchas y pigmentación',
      p2Desc:
        'Radiance es una maravillosa línea con componentes intensivos para tratar las pieles con diferentes tipos de manchas como el melasma, manchas solares, de la edad, pieles con diferentes tonalidades de colores, manchas de acné, entre otras afecciones de pigmentación y decoloraciones desiguales.',
      p2Includes:
        'Leche Limpiadora · Tónico · Crema Humectante · Magic Serum Noche',
      p2Ingredients:
        'Ácido Azelaico, Péptidos, Vitamina C, Ácido Glicólico, AHA, Ácido Tranexámico, Alfa Hidróxido, entre otros.',
      p3Name: 'Premium Hyalurónico',
      p3Tagline: 'Pieles combinadas — deshidratadas',
      p3Desc:
        'Esta combinación de productos es una línea para todo tipo de pieles combinadas, mixtas y deshidratadas con alto grado de ácido hialurónico, entre otros ricos nutrientes ideales para la hidratación intensiva de la piel.',
      p3Includes:
        'Premium Hyaluronic Milk Cleanser · Premium Hyaluronic Toner · Premium Beauty Night Creme',
      p3Ingredients: 'Ácido Hialurónico, Péptidos, Vitaminas.',
      p4Name: 'Purifying Cleanser',
      p4Tagline: 'Pieles Grasas — Acné',
      p4Desc:
        'Es una línea diseñada para pieles grasas y acneicas que se encarga de eliminar el exceso de las glándulas sebáceas y purificar las pieles grasas. Aporta hidratación sin aceite y logra reconstruir la piel luego de los daños del acné o el exceso de sebo facial indeseado.',
      p4Includes: 'Gel Limpiador · Tónico · Crema Hidratante libre de Grasa',
      p4Ingredients:
        'Ácido Salicílico, Niacinamida, Ácido Hialurónico, Magnesio, entre otros.',
    },
    masterclass: {
      badge: 'Formación Profesional',
      title: 'Master Class',
      desc: 'Lorena no solo transforma pieles — también forma a la próxima generación de profesionales de la estética. Con certificación incluida, práctica real, y el respaldo de 19 años de experiencia.',
      highlight1: 'Certificado Incluido',
      highlight2: 'Práctica Real',
      highlight3: '19 Años de Experiencia',
      highlight4: 'Grupos Reducidos',
      cta: 'Reserva tu lugar en la próxima Master Class.',
    },
    facilities: {
      title: 'Nuestro Espacio',
      desc: 'Un ambiente diseñado para tu bienestar — con tecnología de última generación, productos profesionales, y cada detalle pensado para que te sientas como en casa desde el momento que entras.',
      cta: 'Te esperamos en Queens, New York.',
    },
    footer: {
      desc: 'Donde la ciencia estética, la experiencia real, y el calor de nuestra cultura latina se unen en un solo lugar.',
      contact: 'Contacto',
      hours: 'Horario',
      hoursDesc1: 'Lunes a Sábado: 10 AM – 7 PM',
      hoursDesc2: 'Domingo: Cerrado',
      rights: 'Todos los derechos reservados.',
    },
  },
  en: {
    header: {
      services: 'Services',
      about: 'Lorena',
      testimonials: 'Reviews',
      products: 'Lorena Beauty Skin Care - Products',
      space: 'Facilities',
      training: 'Training - Master Class',
      contact: 'Contact',
      book: 'Book Now',
      bookMobile: 'Book',
    },
    hero: {
      title1: 'Tired of Wasting Money on Treatments that ',
      titleHighlight: "Don't Work?",
      subtitle:
        'This is different. And the 50+ clients who fill Google with 5 stars can confirm it.',
      cta: 'Book Your Free Consultation',
    },
    problem: {
      title: 'The Problem',
      titleHighlight: "(And Why It's Not Your Fault)",
      guess: 'Let me guess.',
      tried:
        'You’ve tried creams. You’ve gone to facials. Maybe you even bought those kits sold on Instagram with before-and-afters that look like miracles.',
      stillHere: 'And you are still here.',
      acne: 'With acne that won’t go away.',
      spots: 'With dark spots that return every summer.',
      cellulite: 'With cellulite that makes you avoid the beach.',
      hair: 'With unwanted hair that never seems to leave.',
      notDifficult:
        'It’s not that you are difficult. It’s not that your skin is a "lost cause."',
      wrongTreatment:
        'It’s that no one has given you the right treatment, designed specifically for YOU.',
      generic:
        'Generic spas have generic protocols. They give you the same thing they give the person before and after you. Regardless of your skin tone, your history, your type of spots, your hormonal level, your daily routine.',
      doesntWork: 'And that, in the world of real aesthetics, does not work.',
    },
    truth: {
      title: 'The Truth No One Wants to Tell You',
      loseMoney:
        'Every time you leave a facial without results, you don’t just lose money.',
      loseConfidence: 'You lose confidence.',
      believe:
        'Confidence in treatments. Confidence in your own skin. And little by little, you start to believe that "this is just how you are."',
      accept:
        'That acne is part of your life. That pregnancy spots are here to stay. That accumulated fat has no solution without surgery.',
      lie: 'That is a lie.',
      soldLie:
        'A lie you’ve been sold, treatment after treatment, because no one took the time to truly study your skin.',
    },
    transformation: {
      title: 'The Moment That Changes Everything',
      imagine:
        'Imagine walking into a space where, from the very first second, someone looks at you — not your wallet, not the clock — but you.',
      listen:
        'She listens to you. Examines you. Explains what’s happening with your skin, why it’s happening, and exactly what will be done about it.',
      noGuesses: 'No guesswork. No random products. No empty promises.',
      plan: 'Just a personalized plan, executed with 19 years of clinical experience, state-of-the-art laser technology, and the genuine warmth of someone who loves her work with all her soul.',
      reality:
        'That is what Lorena Beauty House clients experience every time they walk through that door.',
    },
    about: {
      title: 'Meet Lorena Hernández',
      role: 'Founder & Esthetician',
      p1: 'Lorena didn’t arrive in New York with everything figured out.',
      p2: 'She arrived in 2017, leaving behind a 15-year career built in the Dominican Republic, ready to start from scratch in a city that gives nothing away.',
      p3: 'She studied at Christine Valmy, one of the most prestigious esthetics and makeup schools in New York.',
      p4: 'She graduated. Got certified. Got her license. And after all that, the very school where she was a student invited her to become an instructor.',
      p5: '19 years of experience. Two countries. One passion: your skin.',
      cred1Title: 'Certified Esthetician',
      cred1Desc: 'Licensed in the State of New York',
      cred2Title: 'Laser Technician',
      cred2Desc: 'Trained and certified',
      cred3Title: 'Medical Assistant & Phlebotomist',
      cred3Desc: 'Full clinical training',
      cred4Title: 'Certified Teacher',
      cred4Desc: 'Instructor at Christine Valmy School NYC',
      cred5Title: 'International Speaker',
      cred5Desc: 'Workshops in the US and Dominican Republic',
      cred6Title: 'Founder of Lorena Beauty',
      cred6Desc: 'Own line of professional skincare',
      cred7Title: 'EKG Technician',
      cred7Desc: 'Certified Electrocardiogram Technician',
    },
    method: {
      title: 'The Mechanism: Why Lorena Beauty House Works Where Others Fail',
      subtitle1: 'Most spas sell you a service.',
      subtitle2: 'Lorena offers you a protocol.',
      step1Title: 'REAL DIAGNOSIS',
      step1Desc:
        'Before touching your skin, Lorena studies it. Skin type, conditions, history, lifestyle. Your treatment is designed from scratch, just for you.',
      step2Title: 'PRECISION TREATMENT',
      step2Desc:
        'Certified laser technology + Lorena Beauty professional products + advanced body techniques (including wood therapy and body sculpting). There is no single standard treatment. Each session responds to how your skin reacted the time before.',
      step3Title: 'MAINTENANCE & EDUCATION',
      step3Desc:
        'Lorena teaches you. She explains your skin to you. Gives you the tools to maintain results at home. Because an informed client is a client with permanent results.',
    },
    services: {
      title: 'Our Services',
      s1Title: 'Skin Care Facial',
      s1Desc:
        'Deep cleansing, hydration, anti-acne treatment, dark spot treatment',
      s2Title: 'Body Sculpting',
      s2Desc: 'Measurement reduction, toning, body shaping',
      s3Title: 'Venus Legacy',
      s3Desc:
        'Advanced radiofrequency and pulsed magnetic field technology for cellulite reduction, skin tightening, body contouring, and facial rejuvenation. Visible results from the very first session.',
      s4Title: 'Acne & Dark Spots',
      s4Desc: 'Specialized protocols for melasma, hyperpigmentation, scars',
      s5Title: 'Professional Makeup',
      s5Desc: 'Professional techniques, personalized classes',
      s6Title: 'Full SPA',
      s6Desc: 'Total wellness experience, face and body',
      priceTitle: 'Price List & Treatments',
      priceAlt: 'Price list - Lorena Beauty House',
    },
    testimonials: {
      title: 'What Those Who Have Experienced It Say',
      google: '5.0 on Google',
      verified: '53+ Verified Reviews',
      t1: 'I suffer from melasma and Lorena has helped me a lot. Since I started with her my face now looks as beautiful as if I didn’t have melasma.',
      t2: 'The owner Lorena is a wonderful host, she welcomes you with a smile and coffee in hand. The products are personalized according to your skin type.',
      t3: 'Since I started doing spa treatments with her, my face has its glow back. This spa truly attends to its clients with dedication, warmth, and love.',
      t4: 'Getting very good results quickly. Highly recommended for acne cases.',
      t5: 'The results of my laser have been very good. I recommend the place 100%.',
    },
    cta: {
      riskTitle: 'Zero Risk: Your First Consultation Is Free',
      riskP1: 'We know that trust is earned, not asked for.',
      riskP2: 'No pressure. No commitment. No aggressive sales.',
      riskP3:
        'Just a real conversation with Lorena, where we evaluate your skin and tell you exactly what you need — and what you don’t.',
      riskP4:
        'If you don’t feel it’s the right place for you, you leave without spending a dime. But if you feel what everyone who has walked through that door feels... welcome to your new beauty routine.',
      urgencyTitle: 'Real Urgency',
      urgencyDesc1:
        'Lorena and her team of estheticians work exclusively by appointment, because each client receives fully personalized attention. We are not a treatment factory. We are a space of transformation.',
      urgencyDesc2: 'Spots for new clients are limited each week.',
      nextStep: 'The Next Step Is Simple',
      bookBtn: 'Book Your Free Consultation Today',
      memory:
        'Your skin has memory. And the best time to start giving it what it deserves... is today.',
      faqTitle: 'Frequently Asked Questions',
      q1: 'Is it very expensive?',
      a1: 'Your first consultation is free. Treatments are adapted to your needs and budget. Skin treated correctly from the start saves you money on products that don’t work.',
      q2: 'Does laser really work for my skin type?',
      a2: 'Lorena is a certified Laser Technician with experience in all skin types, including Latina skin with pigmentation. Your evaluation is personalized.',
      q3: 'What if I don’t see results?',
      a3: 'Results are documented in over 53 real Google reviews. And your first consultation will allow you to see if the treatment is right before committing.',
      q4: 'I don’t have time',
      a4: 'Lorena works by appointment, which eliminates waiting. Treatments are designed efficiently to fit your schedule.',
      q5: 'I’ve tried everything and nothing works',
      a5: 'That is exactly why Lorena diagnoses first. What hasn’t worked is because it wasn’t designed for your specific skin.',
    },
    products: {
      badge: 'Exclusive Distribution',
      title: 'Lorena Beauty Products',
      desc: 'Professional skincare line developed by Lorena — formulated with high-quality ingredients for real results on your skin.',
      howToLabel: 'How to Use',
      includesLabel: 'Includes',
      ingredientsLabel: 'Ingredients',
      p1Name: 'Grapeseed Oil Serum',
      p1Tagline: 'Grapeseed Oil Blend — Moisturizing antioxidant for daily use',
      p1Desc:
        'This powerful moisturizer absorbs easily into the skin, preventing wrinkles, stretch marks, cellulite, dark spots, scars, acne, and blackheads. It provides antioxidant protection against harmful sun rays and pollution. Suitable for all skin types.',
      p1HowTo: 'Gently massage 3 drops, both morning and night.',
      p1Ingredients:
        'Vitis Vinifera (Grape) Seed Oil, Hydrolyzed Vegetable Protein, Retinyl Palmitate (Vitamin A), L-Ascorbic Acid (Vitamin C), Hydrolyzed Collagen.',
      p2Name: 'Radiance — Pigmented Skin',
      p2Tagline: 'Intensive line for dark spots and pigmentation',
      p2Desc:
        'Radiance is a wonderful line with intensive components to treat skin with different types of dark spots such as melasma, sun spots, age spots, uneven skin tones, acne marks, and other pigmentation conditions and uneven discolorations.',
      p2Includes:
        'Cleansing Milk · Toner · Moisturizing Cream · Magic Night Serum',
      p2Ingredients:
        'Azelaic Acid, Peptides, Vitamin C, Glycolic Acid, AHA, Tranexamic Acid, Alpha Hydroxide, among others.',
      p3Name: 'Premium Hyaluronic',
      p3Tagline: 'Combination & dehydrated skin',
      p3Desc:
        'This product combination is a line for all types of combination, mixed, and dehydrated skin with a high concentration of hyaluronic acid, among other rich nutrients ideal for intensive skin hydration.',
      p3Includes:
        'Premium Hyaluronic Milk Cleanser · Premium Hyaluronic Toner · Premium Beauty Night Creme',
      p3Ingredients: 'Hyaluronic Acid, Peptides, Vitamins.',
      p4Name: 'Purifying Cleanser',
      p4Tagline: 'Oily Skin — Acne',
      p4Desc:
        'A line designed for oily and acne-prone skin that eliminates excess sebaceous gland production and purifies oily skin. It provides oil-free hydration and helps rebuild the skin after acne damage or unwanted excess facial sebum.',
      p4Includes: 'Cleansing Gel · Toner · Oil-Free Moisturizing Cream',
      p4Ingredients:
        'Salicylic Acid, Niacinamide, Hyaluronic Acid, Magnesium, among others.',
    },
    masterclass: {
      badge: 'Professional Training',
      title: 'Master Class',
      desc: "Lorena doesn't just transform skin — she trains the next generation of esthetics professionals. With certification included, real hands-on practice, and the backing of 19 years of experience.",
      highlight1: 'Certificate Included',
      highlight2: 'Hands-On Practice',
      highlight3: '19 Years of Experience',
      highlight4: 'Small Groups',
      cta: 'Reserve your spot in the next Master Class.',
    },
    facilities: {
      title: 'Our Space',
      desc: 'An environment designed for your well-being — with state-of-the-art technology, professional products, and every detail crafted so you feel at home from the moment you walk in.',
      cta: 'We look forward to seeing you in Queens, New York.',
    },
    footer: {
      desc: 'Where aesthetic science, real experience, and the warmth of our Latin culture come together in one place.',
      contact: 'Contact',
      hours: 'Hours',
      hoursDesc1: 'Monday – Saturday: 10 AM – 7 PM',
      hoursDesc2: 'Sunday: Closed',
      rights: 'All rights reserved.',
    },
  },
}
